import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import SectionHeading from "./sectionHeading";

export default function ImageGridSquare({ content }) {
  return (
    <div id="imageGridSquare">
      <SectionHeading title={content.title} subtitle={content.subtitle} />
      <div className="imageGridSquare">
        {content.imageList?.map((image, i) => (
          <LazyLoadImage key={i} alt="logo" effect="blur" src={image.media?.url} />
        ))}
      </div>
    </div>
  );
}
